import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlPlannerV2TravelGroupAddVisitInput } from "~/__generated__/graphql/types";

import { PlannerV2TravelGroupAddVisitDocument } from "../mutations.generated";
import { PlannerV2TravelGroupGetTimelineDocument } from "../queries.generated";

export default function usePlannerV2TravelGroupAddVisit(onSuccess: (plannerTravelGroupId: string) => void) {
    const [mutate, { data, loading, error }] = useMutation(PlannerV2TravelGroupAddVisitDocument, {
        refetchQueries: [PlannerV2TravelGroupGetTimelineDocument],
        awaitRefetchQueries: true,
    });

    const addVisit = useCallback(
        async (input: GqlPlannerV2TravelGroupAddVisitInput) => {
            const response = await mutate({
                variables: { input },
            });
            const plannerTravelGroupId = response.data?.plannerV2TravelGroupAddVisit?.id;
            if (plannerTravelGroupId) onSuccess(plannerTravelGroupId);
        },
        [mutate, onSuccess],
    );

    return {
        addVisit,
        loading,
        error,
        data,
    };
}
